// AUTO-GENERATED SQL Builder (V40 Final) for WhatsAppDevice
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class WhatsAppDeviceSql {
  private ast = new SqlAst('WhatsAppDevice', 'whatsAppDevice');
  public readonly main: any = {};

  public guid: SqlField;
  public instanceId: SqlField;
  public accountId: SqlField;
  public phoneNumber: SqlField;
  public displayName: SqlField;
  public status: SqlField;
  public enabled: SqlField;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('whatsAppDevice', 'guid', '', 'id', 'whatsAppDevice_guid');
    this.instanceId = new SqlField('whatsAppDevice', 'instanceId', '', 'id', 'whatsAppDevice_instance');
    this.accountId = new SqlField('whatsAppDevice', 'accountId', '', 'id', 'whatsAppDevice_account');
    this.phoneNumber = new SqlField('whatsAppDevice', 'phoneNumber', '', 'id', 'whatsAppDevice_phoneNumber');
    this.displayName = new SqlField('whatsAppDevice', 'displayName', '', 'id', 'whatsAppDevice_displayName');
    this.status = new SqlField('whatsAppDevice', 'status', '', 'id', 'whatsAppDevice_status');
    this.enabled = new SqlField('whatsAppDevice', 'enabled', '', 'id', 'whatsAppDevice_enabled');
    this.id = new SqlField('whatsAppDevice', 'id', '', 'id', 'whatsAppDevice_id');
    this.isDeleted = new SqlField('whatsAppDevice', 'isDeleted', '', 'id', 'whatsAppDevice_isDeleted');
    this.createdBy = new SqlField('whatsAppDevice', 'createdBy', '', 'id', 'whatsAppDevice_createdBy');
    this.createdDate = new SqlField('whatsAppDevice', 'createdDate', '', 'id', 'whatsAppDevice_createdDate');
    this.updatedBy = new SqlField('whatsAppDevice', 'updatedBy', '', 'id', 'whatsAppDevice_updatedBy');
    this.updatedDate = new SqlField('whatsAppDevice', 'updatedDate', '', 'id', 'whatsAppDevice_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:WhatsAppDeviceSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:WhatsAppDeviceSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:WhatsAppDeviceSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:WhatsAppDeviceSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:WhatsAppDeviceSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:WhatsAppDeviceSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:WhatsAppDeviceSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:WhatsAppDeviceSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:WhatsAppDeviceSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:WhatsAppDeviceSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
